import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserLoginComponent } from './login/user-login/user-login.component';
import { AuthGuardGuard } from './services/auth-guard.guard';
import { PageNotFoundComponent } from './login/page-not-found/page-not-found.component';
import { environment } from 'src/environments/environment';
import { LoginComponent } from './login/login.component';
const routes: Routes = [
  { path: '', redirectTo: (environment.CLIENT_TYPE === 'fujairah' ? 'login' : 'user-login'), pathMatch: 'full' },
  { path: 'user-login', component: UserLoginComponent },
  { path: 'login', component: LoginComponent },
  { path: 'no-access', component: PageNotFoundComponent },
  { path: 'landing', loadChildren: './layout/layout.module#LayoutModule', canActivate: [AuthGuardGuard] },
  { path: 'iframes', loadChildren: './iframes/iframes.module#IframesModule' },
  { path: 'restart-batches', loadChildren: './layout/setup/batch-runner/batch-runner.module#BatchRunnerModule' },
  { path: 'restart-services', loadChildren: './layout/setup/service-operations/service-operations.module#ServiceOperationsModule' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
